import { Loading } from '@liveauctioneers/hammer-ui-core/loading';
import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { fetchBidderPlaidLinkToken } from '@/redux/modules/account/payments/bankAccount/bankAccount.actions';
import {
    getPlaidError,
    getPlaidFetching,
    getPlaidLinkToken,
} from '@/redux/modules/account/payments/bankAccount/bankAccount.selectors';
import { getBidderId } from '@/redux/modules/account/user/user.selectors';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

import { LaPlaidLinkLink } from './LaPlaidLinkLink';

type Props = {
    useTextStyle?: boolean;
};

const LaPlaidLinkComponent = ({ useTextStyle }: Props) => {
    const dispatch = useAppDispatch();
    const formatMessage = useAppFormatMessage();
    const bidderId = useAppSelector(getBidderId);

    const plaidLinkToken = useAppSelector((state) => getPlaidLinkToken(state, ''));
    const plaidFetching = useAppSelector(getPlaidFetching);
    const plaidError = useAppSelector(getPlaidError);

    useEffect(() => {
        if (!plaidError && !plaidLinkToken && !plaidFetching && bidderId > 0) {
            dispatch(fetchBidderPlaidLinkToken({ bidderId }));
        }
    }, [bidderId, dispatch, plaidError, plaidFetching, plaidLinkToken]);

    if (plaidFetching) {
        return (
            <div
                className="ml-sm flex"
                data-testid="add-bank-account-with-plaid-loading"
            >
                <Loading />
            </div>
        );
    }

    if (plaidError) {
        return <div className="ml-sm flex">{formatMessage(['plaid', 'errorLoading'])}</div>;
    }

    if (plaidLinkToken) {
        return (
            <LaPlaidLinkLink
                plaidLinkToken={plaidLinkToken}
                useTextStyle={useTextStyle}
            />
        );
    }

    return null;
};

export const LaPlaidLink = LaPlaidLinkComponent;
